import { _pHttp } from "../_pHttp";

export async function addLottery(body: any) {
  const { data } = await _pHttp.post(`/lottery`, body);
  return data;
}

export const getLotteryList = async (params: {
  page: number;
  search?: string;
  numberInPage: number;
  match?: number;
}) => {
  const { data } = await _pHttp.get(`lottery/all`, { params });
  return data;
};

